/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1TransportBrandModel } from '../../entities/v1/TransportBrandModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1TransportBrandModelSchema = z.object({
  drivee_id: z.number().int(),
  name: z.string(),
}) as unknown as ToZod<V1TransportBrandModel>